module.exports = __webpack_public_path__ + "img/grainy-gradient.0dcc7c5a.png";